var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "16", height: "31", viewBox: "0 0 16 31", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.905 12.2381C14.43 11.8016 15.2281 11.8522 15.6874 12.3509C16.1468 12.8497 16.0936 13.6078 15.5686 14.0442L8.83179 19.6442C8.35555 20.0401 7.64445 20.0401 7.16821 19.6442L0.431379 14.0442C-0.0936346 13.6078 -0.146836 12.8497 0.312551 12.3509C0.771938 11.8522 1.56995 11.8016 2.09497 12.2381L8 17.1466L13.905 12.2381Z", fill: "#303030" })
  );
});